import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import PropTypes from "prop-types";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: 400,
  p: 4,
};

function KeepMountedModal(props) {
  const {
    isModalActive,
    ariaLabel,
    ariaDescribe,
    imageUrl,
    imageAlt,
    onCloseModal,
  } = props;
  const [open, setOpen] = useState(isModalActive);
  const handleClose = () => setOpen(false);

  const closeModal = () => {
    onCloseModal(false);
  };

  return (
    <Modal
      keepMounted
      open={open}
      onClose={handleClose}
      aria-labelledby={ariaLabel}
      aria-describedby={ariaDescribe}
    >
      <Box sx={modalStyle}>
        <Dialog
          open={open}
          onClose={() => {
            handleClose();
            closeModal();
          }}
        >
          <DialogContent>
            <img src={imageUrl} alt={imageAlt} />
          </DialogContent>
        </Dialog>
      </Box>
    </Modal>
  );
}

KeepMountedModal.propTypes = {
  isModalActive: PropTypes.bool.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  ariaDescribe: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,

  onCloseModal: PropTypes.func.isRequired,
};

export default KeepMountedModal;
